import { render, staticRenderFns } from "./TermsAndConditionsHeader.vue?vue&type=template&id=33fc23cc&scoped=true"
import script from "./TermsAndConditionsHeader.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsHeader.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsHeader.vue?vue&type=style&index=0&id=33fc23cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fc23cc",
  null
  
)

export default component.exports